export default __webpack_public_path__ + "static/media/icon-notif-connexion.b6a55fe9.svg";